
import React, { Fragment } from "react";
import { Show, TabbedShowLayout, TextField, ShowController, Tab, Datagrid, EditButton, ReferenceManyField, FunctionField, useRecordContext, Pagination } from 'react-admin';
import { makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import BulkAssignButton from '../AdminUser/Action/Bulk.Assign.Button';


const PostPagination = ({ record, ...props }) => {
    return (<Pagination rowsPerPageOptions={[10, 20, 30, 50, 100, 200, 300, { value: props.total, label: 'All' }]} {...props} />)
}
const ProfileidFiled = (props) => {
    const record = useRecordContext();
    return (
        <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event) => event.stopPropagation()} />
    )
}

const BulkActionButtons = ({ record, ...props }) => {
    return (<Fragment>
        <BulkAssignButton label="Bulck Assign"  {...props} />


    </Fragment>)
}

const TeamLeaderDetail = ({ ...props }) => {
    const classes = useStyles();
    return (<ShowController {...props}>
        {controllerProps =>
            <Show title="Team Leader Detail" {...props}>
                <TabbedShowLayout>
                    <Tab label="Summary">
                        <TextField source="id" />
                        <TextField source="name" label="Name" />
                        <TextField source="profile_id" label="Profile ID" />
                        <TextField source="telegram_link" label="Telegram Link" />
                    </Tab>

                    <Tab label="Team Members">

                        <ReferenceManyField pagination={<PostPagination />} reference={'teammembers'} target="team_leader_profile_id" label="" filter={{ uid: controllerProps.record ? controllerProps.record.profile_id : 0 }} addLabel={false} >
                            <Datagrid bulkActionButtons={<BulkActionButtons />} classes={{ row: classes.row }} >
                                <TextField source="id" />
                                <ProfileidFiled source="profile_id" label="Profile Id" />
                                <TextField source='name' label="name" />
                                <TextField source='phone' label="phone" />
                                <TextField source='email' label="Email" />
                                <TextField source='telegram_id' label="Telegram ID" />
                                <FunctionField source="status" label="Status" render={record => {
                                    if (record['status'] === 'Reject') {
                                        return (<span style={{ color: 'red' }}>Reject</span>)
                                    } else if (record['status'] === 'Pending') {
                                        return (<span style={{ color: 'orange' }}>Pending</span>)
                                    } else {
                                        return (<span style={{ color: 'green' }}>Approved</span>)
                                    }
                                }} />
                                <TextField source="rejactedby.name" label="Rejacted By" />
                                <TextField source="approved_date" label="Approved Date" />
                                <TextField source="reject_reason" label="Rejected Reason" />
                                <EditButton resource="teammembers" />
                            </Datagrid>
                        </ReferenceManyField>
                    </Tab>






                </TabbedShowLayout>
            </Show>
        }
    </ShowController>
    )
};
const useStyles = makeStyles({
    row: { verticalAlign: "top" },
    actionCell: { width: 100 },
    imageCell: { width: 160 },
    idCell: { width: 80 }
});
export default TeamLeaderDetail
